(function () {
    'use strict';

    angular
        .module('app')
        .controller('PromoPackController', PromoPackController);

    PromoPackController.$inject = ['$log', 'promoModule'];

    function PromoPackController($log, promoModule) {
        const vm = this;

        vm.$onChanges = function () {
            if (vm.download && vm.type === 'concert' && vm.data) {
                handleConcertPromo(vm.data);
            } else if (vm.download && vm.type === 'tour' && vm.data) {
                handleTourPromo(vm.data);
            }
        }

        function handleConcertPromo(concert) {
            const concertImageUrl = getUrlConcert(concert);

            if (vm.download == 'all_files') {
                Promise.all([
                    createFacebookBannerConcert(concertImageUrl, concert),
                    createInstagramPostConcert(concertImageUrl, concert),
                    createInstagramStoryConcert(concertImageUrl, concert),
                    createConcertPhoto(concertImageUrl, concert)
                ]).then((values) => {
                    const zip = new window.JSZip();
                    const file1 = dataURLtoFile(values[0]);
                    const file2 = dataURLtoFile(values[1]);
                    const file3 = dataURLtoFile(values[2]);
                    const file4 = dataURLtoFile(values[3]);

                    zip.file(concert.concert_slug + '-facebook' + '.jpg', file1, { binary: true });
                    zip.file(concert.concert_slug + '-instagram_post' + '.jpg', file2, { binary: true });
                    zip.file(concert.concert_slug + '-instagram_story' + '.jpg', file3, { binary: true });
                    zip.file(concert.concert_slug + '-concert_image' + '.jpg', file4, { binary: true });
                    zip.generateAsync({ type: "blob" }).then(function (blob) {
                        window.saveAs(blob, concert.concert_slug + '_promo' + ".zip");
                    });
                });
            } else if (vm.download == 'facebook_post') {
                createFacebookBannerConcert(concertImageUrl, concert).then(function (response) {
                    const file = dataURLtoFile(response, concert.concert_slug + '-facebook' + '.jpg');
                    window.saveAs(file, concert.concert_slug + '-facebook' + '.jpg');
                });
            } else if (vm.download == 'instagram_post') {
                createInstagramPostConcert(concertImageUrl, concert).then(function (response) {
                    const file = dataURLtoFile(response, concert.concert_slug + '-instagram_post' + '.jpg');
                    window.saveAs(file, concert.concert_slug + '-instagram_post' + '.jpg');
                });
            } else if (vm.download == 'instagram_story') {
                createInstagramStoryConcert(concertImageUrl, concert).then(function (response) {
                    const file = dataURLtoFile(response, concert.concert_slug + '-instagram_story' + '.jpg');
                    window.saveAs(file, concert.concert_slug + '-instagram_story' + '.jpg');
                });
            } else if (vm.download == 'concert_image') {
                createConcertPhoto(concertImageUrl).then(function (response) {
                    const file = dataURLtoFile(response, concert.concert_slug + '-concert_image' + '.jpg');
                    window.saveAs(file, concert.concert_slug + '-concert_image' + '.jpg');
                });
            }
        }

        function dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, { type: mime });
        }

        function getLines(ctx, text, maxWidth) {
            const words = text.split(" ");
            const lines = [];
            let currentLine = words[0];

            for (let i = 1; i < words.length; i++) {
                const word = words[i];
                const width = ctx.measureText(currentLine + " " + word).width;
                if (width < maxWidth) {
                    currentLine += " " + word;
                } else {
                    lines.push(currentLine);
                    currentLine = word;
                }
            }
            lines.push(currentLine);
            return lines;
        }

        function createFacebookBannerConcert(url, concert) {
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = 1200;
                    canvas.height = 630;

                    const ctx = canvas.getContext("2d");
                    const scaledHeight = 1200 * image.height / image.width;
                    ctx.drawImage(image, 0, -((scaledHeight - canvas.height) / 2), 1200, 1200 * image.height / image.width);

                    const greyOverlay = ctx.createLinearGradient(0, 0, 0, 630);
                    greyOverlay.addColorStop(0, 'rgba(0, 0, 0, 0.2)');
                    greyOverlay.addColorStop(1, 'rgba(0, 0, 0, 0.6)');
                    ctx.fillStyle = greyOverlay;
                    ctx.fillRect(0, 0, 1200, 630);

                    ctx.font = "70px Euclid-semibold";
                    ctx.fillStyle = "white";

                    const numLines = getLines(ctx, concert.concert_name, 900);
                    if (numLines.length == 2) {
                        ctx.fillText(numLines[0], 62, 334);
                        ctx.fillText(numLines[1], 62, 404);
                    } else {
                        ctx.fillText(concert.concert_name, 62, 404);
                    }

                    ctx.font = "60px Euclid-medium";
                    ctx.fillText(concert.concert_city, 62, 488);

                    ctx.font = "60px Euclid-medium";
                    ctx.fillText(moment(concert.concert_start_time).format('D. MMMM YYYY'), 62, 564);

                    var img = document.createElement('IMG');

                    img.onload = function () {
                        var x = 1200 - 370
                        var y = 630 - 205
                        ctx.drawImage(img, x, y, 370, 185);
                        ctx.translate(1019, 541);
                        resolve(canvas.toDataURL("image/jpeg"));
                    }

                    img.src = '/img/BMC-logo-transparent.svg';

                };
                image.src = url;
            });
        }

        function createInstagramPostConcert(url, concert) {
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = 1080;
                    canvas.height = 1080;

                    const ctx = canvas.getContext("2d");
                    const scaledWidth = image.width * (1080 / image.height);
                    ctx.drawImage(image, -((scaledWidth - 1080) / 2), 0, scaledWidth, 1080);

                    const greyOverlay = ctx.createLinearGradient(0, 0, 0, 1080);
                    greyOverlay.addColorStop(0, 'rgba(0, 0, 0, 0.2)');
                    greyOverlay.addColorStop(1, 'rgba(0, 0, 0, 0.6)');
                    ctx.fillStyle = greyOverlay;
                    ctx.fillRect(0, 0, 1080, 1080);

                    ctx.font = "70px Euclid-semibold";
                    ctx.fillStyle = "white";

                    const topMargin = 440;

                    const numLines = getLines(ctx, concert.concert_name, 900);
                    if (numLines.length == 2) {
                        ctx.fillText(numLines[0], 62, 334 + topMargin);
                        ctx.fillText(numLines[1], 62, 404 + topMargin);
                    } else {
                        ctx.fillText(concert.concert_name, 62, 404 + topMargin);
                    }

                    ctx.font = "60px Euclid-medium";
                    ctx.fillText(concert.concert_city, 62, 488 + topMargin);

                    ctx.font = "60px Euclid-medium";
                    ctx.fillText(moment(concert.concert_start_time).format('D. MMMM YYYY'), 62, 564 + topMargin);


                    var img = document.createElement('IMG');

                    img.onload = function () {
                        var x = 1080 - 370
                        var y = 1080 - 215
                        ctx.drawImage(img, x, y, 370, 185);
                        ctx.translate(900, 541 + topMargin);
                        resolve(canvas.toDataURL("image/jpeg"));
                    }

                    img.src = '/img/BMC-logo-transparent.svg';

                };
                image.src = url;
            });
        }

        function createInstagramStoryConcert(url, concert) {
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = 1080;
                    canvas.height = 1920;

                    const ctx = canvas.getContext("2d");
                    const scaledWidth = image.width * (1920 / image.height);
                    ctx.drawImage(image, -((scaledWidth - 1080) / 2), 0, scaledWidth, 1920);

                    const greyOverlay = ctx.createLinearGradient(0, 0, 0, 1920);
                    greyOverlay.addColorStop(0, 'rgba(0, 0, 0, 0.2)');
                    greyOverlay.addColorStop(1, 'rgba(0, 0, 0, 0.6)');
                    ctx.fillStyle = greyOverlay;
                    ctx.fillRect(0, 0, 1080, 1920);

                    const topMargin = 886;

                    ctx.font = "90px Euclid-semibold";
                    ctx.fillStyle = "white";

                    let numLines = getLines(ctx, concert.concert_name, 800);
                    if (numLines.length == 2) {
                        ctx.fillText(numLines[0], 62, 330 + topMargin);
                        ctx.fillText(numLines[1], 62, 420 + topMargin);
                    } else if (numLines.length == 3) {
                        ctx.fillText(numLines[0], 62, 240 + topMargin);
                        ctx.fillText(numLines[1], 62, 330 + topMargin);
                        ctx.fillText(numLines[2], 62, 420 + topMargin);
                    } else {
                        ctx.fillText(concert.concert_name, 62, 420 + topMargin);
                    }

                    ctx.font = "80px Euclid-medium";
                    ctx.fillText(moment(concert.concert_start_time).format('D. MMMM YYYY'), 62, 534 + topMargin);

                    numLines = getLines(ctx, concert.concert_city, 800);
                    if (numLines.length == 2) {
                        ctx.fillText(numLines[0], 62, 634 + topMargin);
                        ctx.fillText(numLines[1], 62, 714 + topMargin);
                    } else if (numLines.length == 3) {
                        ctx.fillText(numLines[0], 62, 634 + topMargin);
                        ctx.fillText(numLines[1], 62, 714 + topMargin);
                        ctx.fillText(numLines[2], 62, 794 + topMargin);
                    } else {
                        ctx.fillText(concert.concert_city, 62, 634 + topMargin);
                    }

                    var img = document.createElement('IMG');

                    img.onload = function () {
                        var x = 10
                        var y = 1920 - 185
                        ctx.drawImage(img, x, y, 370, 185);
                        ctx.translate(62, 930 + topMargin);
                        resolve(canvas.toDataURL("image/jpeg"));
                    }

                    img.src = '/img/BMC-logo-transparent.svg';
                };
                image.src = url;
            });
        }

        function createConcertPhoto(url) {
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = 1920;
                    canvas.height = 1278;

                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(image, 0, 0, 1920, 1278);
                    resolve(canvas.toDataURL("image/jpeg"));
                };
                image.src = url;
            });
        }

        function getUrlConcert(concert) {
            return '/uploads/' + (concert.band_image_hash ? 'bands/' + concert.band.band_slug + '/' + concert.band_image_hash : 'concerts/' + concert.concert_slug + '/1') + '_xl.jpeg';
        }

        function handleTourPromo(tour) {
            if (vm.download == 'all_files') {
                Promise.all([
                    createTourPromo(tour, 1920, 1080),
                    createTourPromo(tour, 1080, 1080),
                    createTourPromo(tour, 1080, 1920),
                ]).then((values) => {
                    const zip = new window.JSZip();
                    const file1 = dataURLtoFile(values[0]);
                    const file2 = dataURLtoFile(values[1]);
                    const file3 = dataURLtoFile(values[2]);

                    zip.file(tour.slug + '-facebook' + '.jpg', file1, { binary: true });
                    zip.file(tour.slug + '-instagram_post' + '.jpg', file2, { binary: true });
                    zip.file(tour.slug + '-instagram_story' + '.jpg', file3, { binary: true });
                    zip.generateAsync({ type: "blob" }).then(function (blob) {
                        window.saveAs(blob, tour.slug + '_promo' + ".zip");
                    });
                });
            } else if (vm.download == 'facebook_post') {
                createTourPromo(tour, 1920, 1080).then(function (response) {
                    const file = dataURLtoFile(response, tour.slug + '-facebook' + '.jpg');
                    window.saveAs(file, tour.slug + '-facebook' + '.jpg');
                });
            } else if (vm.download == 'instagram_post') {
                createTourPromo(tour, 1080, 1080).then(function (response) {
                    const file = dataURLtoFile(response, tour.slug + '-instagram_post' + '.jpg');
                    window.saveAs(file, tour.slug + '-instagram_post' + '.jpg');
                });
            } else if (vm.download == 'instagram_story') {
                createTourPromo(tour, 1080, 1920).then(function (response) {
                    const file = dataURLtoFile(response, tour.slug + '-instagram_story' + '.jpg');
                    window.saveAs(file, tour.slug + '-instagram_story' + '.jpg');
                });
            }
        }

        function createTourPromo(tour, width, height) {
            const bandUrl = '/uploads/bands/' + tour.band.band_slug + '/' + tour.band.primary_image + '_xl.jpeg';

            return new Promise(function (resolve) {
                const image = new Image();
                image.onload = function () {
                    const orange = '#ff7011';
                    const isHorizontal = width > height;

                    const leftMargin = 62;
                    const marginTextTopBottom = 62;

                    // Height of date and location, including margin
                    const concertHeight = 130;
                    const concertListHeight = concertHeight * tour.concerts.length - 50; // Subtract 50 to account for an extra margin at the bottom.

                    // Height of tour and band labels
                    const tourHeight = 90;
                    const bandHeight = 80;

                    // Margin between concert list, tour and band labels
                    const totalTextHeight = concertListHeight + tourHeight + bandHeight;
					const totalTextHeightWithMargin = (marginTextTopBottom*2) + totalTextHeight;

                    // The top margin is calculated by saying that the concert
                    // list should always end at the bottom of the promo image
                    // or the text should be centered (if there is lots of
                    // space) This top margin also somewhat determines how big
                    // the band image can be.
                    const topMargin = isHorizontal
                        ? (height - totalTextHeightWithMargin) / 2
                        : height - totalTextHeightWithMargin;
                    let currentTopMarginForText = topMargin + marginTextTopBottom;

                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;

                    let targetHeight = isHorizontal ? canvas.height : topMargin;
                    const scaleFactor = targetHeight / image.height;
                    let targetWidth = image.width * scaleFactor;

                    const widthComparison = isHorizontal ? canvas.width / 2 : canvas.width;

                    if (targetWidth < widthComparison) {
                        targetWidth = widthComparison;
                        const heightScaleFactor = targetWidth / image.width;
                        targetHeight = image.height * heightScaleFactor;
                    }

                    $log.debug('Image target', targetWidth, targetHeight)

                    // Dynamic gradient stop in height but not width
                    const gradientStop = isHorizontal ? 0.5 : targetHeight / height;

                    const xOffset = isHorizontal ? canvas.width / 2 : 0;

                    const ctx = canvas.getContext('2d');
                    ctx.fillStyle = 'rgb(50,30,76)';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(image, xOffset - ((targetWidth - widthComparison) / 2), 0, targetWidth, targetHeight);

                    const purpleOverlay = ctx.createLinearGradient(
                        isHorizontal ? canvas.width : 0,
                        0,
                        0,
                        isHorizontal ? 0 : canvas.height
                    );
                    purpleOverlay.addColorStop(0, 'rgba(50,30,76,0)');
                    purpleOverlay.addColorStop(gradientStop, 'rgba(50,30,76,1.0)');
                    ctx.fillStyle = purpleOverlay;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    ctx.font = '37px Euclid-semibold';
                    ctx.fillStyle = orange;
                    ctx.fillText(tour.name.toUpperCase(), leftMargin, currentTopMarginForText);

                    currentTopMarginForText += tourHeight;

                    ctx.font = '70px Euclid-semibold';
                    ctx.fillStyle = 'white';
                    ctx.fillText(tour.band.band_name, leftMargin, currentTopMarginForText);

                    currentTopMarginForText += bandHeight;

                    for (let i = 0; i < tour.concerts.length; i++) {
                        const concert = tour.concerts[i];

                        const leftMarginText = leftMargin + 45;

                        // Save context as it is now.
                        ctx.save();

                        const path = new Path2D("M29.25 19.5a9.75 9.75 0 1 1 0 19.499 9.75 9.75 0 0 1 0-19.499zM4.667 45.117l.147.212c.178.268.365.529.552.813l21.175 30.44a3.306 3.306 0 0 0 5.427 0l21.125-30.417c.203-.284.398-.56.593-.813l.13-.195a29.286 29.286 0 0 0-5.393-37.991 29.24 29.24 0 0 0-38.347 0 29.287 29.287 0 0 0-5.392 37.992l-.017-.04z");
                        ctx.fillStyle = orange;
                        ctx.translate(leftMargin, currentTopMarginForText - 30);
                        ctx.scale(0.45, 0.45);
                        ctx.fill(path);

                        // Restore context to previous.
                        ctx.restore();

                        ctx.font = "normal 500 38px Euclid-medium";
                        ctx.fillText(moment(concert.concert_start_time).format('LL'), leftMarginText, currentTopMarginForText);

                        ctx.font = "normal 300 38px Euclid-regular";
                        ctx.fillText(concert.space_name + ', ' + concert.concert_city, leftMarginText, currentTopMarginForText + 50);

                        currentTopMarginForText += concertHeight;
                    }

                    // The below adds a Low-fi logo -- removed for now.
                    // ctx.save();
                    // const path = new Path2D('M32.382 15.909c9.507 3.08 14.163 12.711 11.207 21.838-2.956 9.127-12.373 14.201-21.881 11.122-9.57-3.099-14.225-12.73-11.269-21.858 2.955-9.126 12.372-14.2 21.943-11.102zM5.73.399v48.636H0V.4h5.73zm45.162 15.325 8.06 24.317 8.33-24.317h4.397l8.328 24.317 8.062-24.317h6.062l-11.327 33.31h-5.062L69.546 25.05l-8.262 23.985H56.22L44.894 15.724h5.997zM150.744 1.73v5.198h-9.26v8.795h9.26v5.196h-9.26v28.115h-5.663V20.92h-5.796v-5.196h5.796V1.73h14.923zm9.724 13.992v33.311h-5.729v-33.31h5.73zM16.016 28.818c-2.051 6.339.743 12.846 7.334 14.98 6.592 2.134 12.608-1.52 14.66-7.857 2.053-6.34-.678-12.826-7.27-14.961-6.592-2.134-12.67 1.5-14.724 7.838zm109.818-1.302v5.73H96.92v-5.73h28.914zM157.67 0c2.264 0 4.063 1.866 4.063 4.063a4.037 4.037 0 0 1-4.063 4.064c-2.266 0-4.131-1.799-4.131-4.064 0-2.197 1.865-4.063 4.13-4.063z');
                    // ctx.translate(canvas.width - 200, targetHeight);
                    // ctx.fill(path);
                    // ctx.restore();

                    resolve(canvas.toDataURL("image/jpeg"));
                };
                image.src = bandUrl;
            });
        }
    }
})();
